/* eslint-disable */
import {reactive, toRefs} from "vue";

const state = reactive({
    Zoom: 9.5,
    Center: undefined,
    Bounds: undefined
});


export default {...toRefs(state)};
